/**
 * MM Avis Manager - Moon Moon Agency
 * Init Splide section MM-Avis + cable les fleches pagination custom (← X/N →)
 *
 * Cf. .claude/rules/javascript.md (Manager pattern).
 */

/*********************************************************************************************
 * 💬 MM AVIS MANAGER
 */
const MMAvisManager = {
	config: {
		selectors: {
			section:  '[data-avis-section]',
			slider:   '[data-avis-slider]',
			prev:     '[data-avis-prev]',
			next:     '[data-avis-next]',
			counter:  '[data-avis-counter]',
		},
	},

	init() {
		document.querySelectorAll(this.config.selectors.section).forEach(s => this._initSection(s));
	},

	_initSection(section) {
		const sliderEl = section.querySelector(this.config.selectors.slider);
		if (!sliderEl || typeof Splide === 'undefined') return;

		let config;
		try { config = JSON.parse(sliderEl.dataset.splide || '{}'); }
		catch (_) { config = {}; }

		const splide = new Splide(sliderEl, config).mount();
		sliderEl._splide = splide;

		const prev = section.querySelector(this.config.selectors.prev);
		const next = section.querySelector(this.config.selectors.next);
		const counter = section.querySelector(this.config.selectors.counter);

		prev?.addEventListener('click', () => splide.go('<'));
		next?.addEventListener('click', () => splide.go('>'));

		const update = () => {
			try {
				const total = splide.length;
				const idx = splide.index;
				const perPage = splide.options.perPage || 1;
				const totalPages = Math.max(1, total - perPage + 1);
				if (counter) counter.textContent = `${idx + 1}/${totalPages}`;
				if (prev) prev.toggleAttribute('disabled', idx <= 0);
				if (next) next.toggleAttribute('disabled', idx + perPage >= total);
			} catch (_) {}
		};
		splide.on('mounted move moved resized', update);
		update();
	},
};

/*********************************************************************************************
 * 🚀 INIT
 */
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => MMAvisManager.init());
} else {
	MMAvisManager.init();
}

window.MMAvisManager = MMAvisManager;
